import { render, staticRenderFns } from "./base-switch.vue?vue&type=template&id=03a1f2b5"
import script from "./base-switch.ts?vue&type=script&lang=ts&external"
export * from "./base-switch.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports